<div class="flex relative overflow-hidden min-h-screen flex-col justify-center py-12 lg:px-8 bg-gray-50">
    <app-background></app-background> <!-- CIRCULOS DEL FONDO DE LA PAGINA-->
    <div class="mt-10 sm:mx-auto sm:w-full max-w-[540px]">
        <div class="bg-white opacity-99 px-6 py-12 rounded-lg sm:px-12">
            <div class="sm:mx-auto sm:w-full sm:max-w-md">
                <img class="mx-auto h-10 md:h-12 w-auto" src="../../assets/img/LogoHos.svg" alt="Cognitive">
            </div>

            <div>
                <div class="justify-center mt-4 xl:mt-6">
                    <p class="text-center text-cyan-400 text-2xl md:text-3xl leading-8 font-medium">
                        Sesión Cerrada</p>
                </div>
                <div class="justify-center mt-4 xl:mt-6">
                    <p class="text-center text-gray-500 text-sm md:text-sm leading-5 font-medium">
                        Has cerrado sesión correctamente. Debes volver a</p>
                    <p class="text-center text-gray-500 text-sm md:text-sm leading-5 font-medium">
                        iniciar sesión para utilizar Hospify.</p>
                </div>
                <div class="relative mt-4 xl:mt-6">
                    <div class="absolute inset-0 flex" aria-hidden="true">
                        <div class="w-full border-t-2 border-gray-200"></div>
                    </div>
                    <div class="relative flex justify-center text-sm/6 font-medium">
                        <a routerLink="/auth"
                            class="font-semibold text-gray-900 hover:text-pink-500 mt-4 md:text-sm">Iniciar
                            Sesión</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>